export const DEFAULT_ONE_SLIDE = 1;
export const DEFAULT_ONE_THOUSAND = 1000;
export const ONE_HUNDRED = 100;
export const HALF_SECOND = 500;
// This makes continue button appear and disappear halfway through the last slide
export const DEFAULT_HALF_OF_THE_SCREEN = 2;
